import React from 'react';
import Icon from '../../../components/common/Icon/Icon';
import styles from './SecurityNotice.module.css';

interface SecurityNoticeProps {
  /** Renders as helper text under a section label instead of the shield banner. */
  placement?: 'default' | 'belowLabel';
}

const SECURITY_NOTICE_TEXT =
  'Seus dados estão protegidos e serão utilizados apenas para a contratação da consultoria.';

const SecurityNotice: React.FC<SecurityNoticeProps> = ({ placement = 'default' }) => {
  if (placement === 'belowLabel') {
    return (
      <p className={styles.belowLabel} role="note">
        {SECURITY_NOTICE_TEXT}
      </p>
    );
  }

  return (
    <div className={styles.notice} role="note">
      <Icon name="shield" size={20} className={styles.icon} aria-hidden />
      <p className={styles.text}>{SECURITY_NOTICE_TEXT}</p>
    </div>
  );
};

export default SecurityNotice;
